import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';

import { Globals } from '../globals';

export interface ConstantCost {
  active: number;
  createdAt: any;
  updatedAt: any;
  folio: string;
  description: string;
  value: number;
}

interface ConstantCostId extends ConstantCost {
  id: string;
}

@Injectable()
export class ConstantCostsService {

  constantCost: Observable<ConstantCostId>

  constantCosts$: Observable<any>

  collection: string;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router
  ) {
    this.collection = Globals.CONSTANT_COSTS_COLLECTION;
  }

  /**
   * Get constantCosts with references
   * @return {Observable} Arrays of constantCosts
   */
  getConstantCosts() {
    return this.afh.colWithIds$(this.collection, ref => ref.orderBy('folio'));
  }
  getConstantCost(id: string) {
    return this.constantCosts$ = this.afh.docWithIds$(this.collection + '/' + id);
  }

  /**
  * Create new inAndOut
  * @param {InAndOut} inAndOut - The data of the inAndOut
  */
  addConstantCost(constantCost: ConstantCost) {
    this.afh.add(`${this.collection}`, constantCost);
    this.router.navigate(['/costs']);
  }
  deleteConstantCost(costId: string){
    this.afh.delete(`${this.collection}/${costId}`);
  }
    /**
   * Update current constantCost
   * @param {string} idd  - The id of the constantCost
   * @param {constantCost} constantCost - The data of the constantCost
   */
  updateConstantCost(id: string, constantCost: ConstantCost) {
    this.afh.update(`${this.collection}/${id}`, constantCost);
    this.router.navigate(['/costs']);
  }

}
